import {IObservable, mkObservable} from "./Observable";
export const catchError = <T>(catcher: ((ex: any) => IObservable<T>)) => (source: IObservable<T>) => mkObservable<T>(observer => {
  source.subscribe({
    next: i => observer.next(i),
    error: err => catcher(err).subscribe(observer),
    complete: () => observer.complete()
  });
});
